import { Injectable } from '@angular/core';
import { HttpService } from '../../http/http.service';
import { GeneralResponse } from '../../models/general-response/general-response';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { IContentManager } from '../../models/content-manager/icontent-manager';

@Injectable({
  providedIn: 'root'
})
export class ContentManagerService {

  constructor(private _http: HttpService,
              private _storage: LocalStorageService) { }

  getAllItems():Observable<IContentManager>{
    return this._http.get<GeneralResponse<IContentManager>>(
      environment.GESTOR_DE_CONTENIDO_URL,
      '/items'
    ).pipe(map((response => {
      this._storage.stringifyItem(environment.LOCAL_STORAGE.GESTOR_CONTENIDO, response);
      return response.body;
    })));
  }

  getConfiguraciones():Observable<GeneralResponse<any>>{
    return this._http.get<GeneralResponse<any>>(
      environment.GESTOR_DE_CONTENIDO_URL,
      '/configuraciones'
    ).pipe(map((response => {
      return response;
    })));
  }
}
